import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import LegalStatementV3 from './LegalStatement/LegalStatementV3'
import ContentfulFormV3 from './ContentfulFormV3/ContentfulFormV3'
import ContentfulGrid from './Grid/ContentfulGrid'
import RichTextBlockV3 from './RichTextBlock/RichTextBlockV3'
import ButtonV3 from './Utilities/Buttons/V3/ButtonV3'
import ContentfulButtonV3 from './Utilities/Buttons/V3/ContentfulButtonV3'
import TextLink from './Utilities/TextLink/TextLink'
import Stats from './Stats'
import InfoCard from './Cards/InfoCard'
import Headline from './Headline/Headline'
import TrustPilotV3 from './Utilities/TrustPilotV3/TrustPilotV3'

function ReferenceComponentRenderer({ contentType, node, insideRichText, event }) {
  const components = {
    ContentfulHeadline: <Headline data={node} grid embed />,
    ContentfulInfoCard: <InfoCard data={node} />,
    ContentfulStats: <Stats data={node} />,
    ContentfulColumnsV3: <ContentfulGrid data={node} />,
    ContentfulLegalStatement: <LegalStatementV3 fields={node} />,
    ContentfulFormV3: <ContentfulFormV3 data={node} />,
    ContentfulTextBlock: insideRichText ? null : <RichTextBlockV3 data={node} />,
    ContentfulImageWithText: <GatsbyImage image={getImage(node.image)} alt={node.altText} />,
    ContentfulButton: event ? (
      <ButtonV3 data={node} onClick={event} />
    ) : (
      <ContentfulButtonV3 data={node} />
    ),
    ContentfulTextLink: <TextLink data={node} />,
    ContentfulTrustPilot: <TrustPilotV3 data={node} />
  }
  return components[contentType]
}

export default ReferenceComponentRenderer
